<template>
  <div class="background">
    <transition name="fade" mode="out-in">
      <div>
        <router-view />
      </div>
    </transition>
    
   
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


</style>